/**
 * 正誤判定の共通ユーティリティ（AGG-10対応）
 *
 * バックエンド（集計・ランキング・回答履歴）は「最初の is_correct=true の選択肢のみを正解」
 * として判定する（question-utils.getCorrectChoiceNum）。
 * フロントエンドの従来実装は「選択した選択肢の is_correct フラグ」で判定していたため、
 * 複数の選択肢に is_correct=true が設定された不正データの場合に
 * バックエンドと判定が食い違っていた。ここで定義を統一する。
 */
import type { Question } from '../types';

/**
 * 問題の正解選択肢ID を返す（最初の is_correct=true の選択肢）
 *
 * @returns 正解選択肢の id、正解が存在しない場合は null
 */
export function getCorrectChoiceId(question: Question): number | null {
  const correctChoice = question.choices.find((c) => c.is_correct);
  return correctChoice?.id ?? null;
}

/**
 * 選択した選択肢が正解かどうかを判定する
 *
 * @param question 問題
 * @param selectedChoiceId 選択した選択肢ID（未回答は null / undefined）
 */
export function isCorrectAnswer(
  question: Question,
  selectedChoiceId: number | null | undefined,
): boolean {
  if (selectedChoiceId === undefined || selectedChoiceId === null) {
    return false;
  }
  const correctChoiceId = getCorrectChoiceId(question);
  return correctChoiceId !== null && selectedChoiceId === correctChoiceId;
}
